<template>
    <div class="btec_home">
        <div class="a1">
            <div class="a1_cont">
                <p class="p1">国际课程</p>
                <p class="p2">BTEC</p>
                <p class="p3">培生爱德思考试局官方授权办学中心、考试中心</p>
            </div>
        </div>
        <div class="a2">
            <div class="a2_position"></div>
            <div class="section_title">
                <span class="section_cn">什么是BTEC课程？</span>
                <p class="section_en"></p>
            </div>
            <div class="a2_cont">
                <div class="a2_left">
                    <div class="a2_left_item" @click="scrolla2item(0)">
                        <img src="../img/alevel/Star 2.png" alt="">
                        <p>BTEC 课程介绍</p>
                    </div>
                    <div class="a2_left_item" @click="scrolla2item(1)">
                        <img src="../img/alevel/Star 2.png" alt="">
                        <p>BTEC 课程优势</p>
                    </div>
                    <div class="a2_left_item" @click="scrolla2item(2)">
                        <img src="../img/alevel/Star 2.png" alt="">
                        <p>RoSSo的服务与优势</p>
                    </div>
                    <div class="a2_left_item" @click="scrolla2item(3)">
                        <img src="../img/alevel/Star 2.png" alt="">
                        <p>官方资料参考</p>
                    </div>
                </div>
                <div class="a2_right">
                    <div class="a2_right_text">
                        <div style="margin-bottom: 10px;">
                            培生爱德思（Edexcel）开设的BTEC Level 4 Foundation Diploma in Art, Design and Media Practice简称BTEC艺术预科课程。BTEC课程注重培养学生的实践能力和创新能力，引导学生通过项目制学习不断优化、完善自己的艺术作品集。<span>BTEC课程适合16周岁及以上，高中毕业或在读学生，无艺术基础及语言要求。</span>
                        </div>
                       <div style="margin-bottom: 10px;">
                        顺利完成BTEC预科学习的学生将获得培生爱德思（Pearson Edexcel）官方颁发的 BTEC Level 4 艺术与设计预科证书，证书受到英国资格认证及考试监管办公室Ofqual认可，<span>其证书效力等同于英国大学开设的预科课程。</span>作为本科直录的核心课程，BTEC预科匹配英美大学艺术设计类专业的申请要求，并受到全球艺术类院校的广泛认可。 
                    
                       </div>
                       同时，BTEC课程体系属于英国中高等职业教育，被誉为“升学就职的金牌职业教育体系”，对学生未来求职和技能提升有很大帮助。
                    </div>
                    <div class="a2_right_imgbox">
                        <div class="img1box">
                            <img src="../img/BTEC/btec.jpg" alt="" class="img1" @click="imgCover($event)">
                            <img src="../img/alevel/Group 631.png" alt="" class="img1_2" @click="imgCover($event)">
                            <img src="../img/alevel/Group 630.png" alt="" class="img2  wow  rotateInDownLeft">
                        </div>
                        <p>* 培生爱德思对RoSSo师资、硬件设施、教学体系、运营状况进行了全方位评估和考核后，授予BTEC办学&考试中心资质</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="a3">
            <div class="a2_position"></div>
            <div class="section_title">
                <span class="section_cn">BTEC课程优势</span>
                <p class="section_en"></p>
            </div>
            <div class="a3_cont">
                <div class="a3_item" @click="a3itemClick(0)">
                    <img src="../img/alevel/Group 632-1.png" alt="" class="a3_item_bgc">
                    <div class="a3_item_text">
                        <div class="a3_item_text_title">本科直录核心课程</div>
                        <div class="a3_item_text_cont">BTEC预科是本科直录的核心课程，匹配英美名校入学要求，帮助学生在院校申请中提升竞争力。</div>

                        <img src="../img/alevel/Group 643.png" alt="" class="a3_item_text_icon">
                    </div>
                </div>
                <div class="a3_item" @click="a3itemClick(1)">
                    <img src="../img/alevel/Group 637-1.png" alt="" class="a3_item_bgc">
                    <div class="a3_item_text">
                        <div class="a3_item_text_title">课程产出同步作品集</div>
                        <div class="a3_item_text_cont">BTEC产出可以和院校申请作品集高效融合，实现预科学习和作品集创作、院校申请的高效同步。</div>

                        <img src="../img/alevel/Group 643.png" alt="" class="a3_item_text_icon">
                    </div>
                </div>
                <div class="a3_item" @click="a3itemClick(2)">
                    <img src="../img/alevel/Group 634-1.png" alt="" class="a3_item_bgc">
                    <div class="a3_item_text">
                        <div class="a3_item_text_title">高性价比预科课程</div>
                        <div class="a3_item_text_cont">在国内完成预科学习，免去英国一年预科学习时间，省时省力，高性价比。</div>

                        <img src="../img/alevel/Group 643.png" alt="" class="a3_item_text_icon">
                    </div>
                </div>
                <div class="a3_item" @click="a3itemClick(3)">
                    <img src="../img/alevel/Group 540-1.png" alt="" class="a3_item_bgc">
                    <div class="a3_item_text">
                        <div class="a3_item_text_title">提高申请竞争力</div>
                        <div class="a3_item_text_cont">预科阶段的优异成绩可以有效弥补前阶段学术成绩的不足，提升申请竞争力</div>

                        <img src="../img/alevel/Group 643.png" alt="" class="a3_item_text_icon">
                    </div>
                </div>
                <div class="a3_item" @click="a3itemClick(4)">
                    <img src="../img/alevel/Group 633-1.png" alt="" class="a3_item_bgc">
                    <div class="a3_item_text">
                        <div class="a3_item_text_title">考核形式灵活</div>
                        <div class="a3_item_text_cont">BTEC考核为完成项目制学习后提交艺术作品进行评估，适合艺术方向学生发挥自身特长。</div>

                        <img src="../img/alevel/Group 643.png" alt="" class="a3_item_text_icon">
                    </div>
                </div>
                <div class="a3_item" @click="a3itemClick(5)">
                    <img src="../img/alevel/Group 635-1.png" alt="" class="a3_item_bgc">
                    <div class="a3_item_text">
                        <div class="a3_item_text_title">为文书添砖加瓦</div>
                        <div class="a3_item_text_cont">BTEC阶段的国际课程学习背景和艺术学习经历，可以帮助学生在文书中体现对艺术的热爱，以及明确的艺术方向学习规划，助力本科院校申请。</div>

                        <img src="../img/alevel/Group 643.png" alt="" class="a3_item_text_icon">
                    </div>
                </div>
                <div class="a3_item" @click="a3itemClick(6)">
                    <img src="../img/alevel/Group 636-1.png" alt="" class="a3_item_bgc">
                    <div class="a3_item_text">
                        <div class="a3_item_text_title">提前适应国外教育模式</div>
                        <div class="a3_item_text_cont">有助于学生提前适应国外艺术教育模式和评价体系，为后续本科、研究生阶段的专业学习夯实基础。
                        </div>

                        <img src="../img/alevel/Group 643.png" alt="" class="a3_item_text_icon">
                    </div>
                </div>

            </div>
        </div>

        <div class="a4">
            <div class="a2_position"></div>
            <div class="tag tag1"># 一对一</div>
            <div class="tag tag2"># BTEC</div>
            <div class="tag tag3"># 个性化教学</div>
            <div class="section_title">
                <span class="section_cn">RoSSo的服务与优势</span>
                <p class="section_en"></p>
            </div>
            <div class="a4_cont">
                <div class="a4_cont_title">
                    RoSSo是培生爱德思官方授权的BTEC办学中心、考试中心，匹配爱德思官方教学要求开设了BTEC Level 4 Foundation Diploma预科课程。顺利完成BTEC预科学习的学生将获得培生爱德思（Pearson Edexcel）官方颁发的 BTEC Level 4 艺术与设计预科证书。<br><br>BTEC预科课程级别等同于英国大学开设的预科课程，也是本科直录的核心课程，匹配英美大学艺术设计类专业的申请要求。
                </div>
                <div class="a4_main">
                    <div class="a4_main_left">
                        <div class="a4_main_left_item" @click="dotClick(0)" style="font-weight: bold;">
                            <p> </p>
                            <span>开设科目</span>
                        </div>
                        <div class="a4_main_left_item" @click="dotClick(1)">
                            <p> </p>
                            <span>RoSSo优势</span>
                        </div>
                        <div class="a4_main_left_item" @click="dotClick(2)">
                            <p> </p>
                            <span>课程亮点</span>
                        </div>
                    </div>
                    <div class="a4_main_right">
                        <div class="a4_main_dot">
                            <div class="a4_main_dot_prev" @click="a4prev">
                                <div class="line1"></div>
                                <div class="line2"></div>
                            </div>
                            <div class="a4_main_dot_next" @click="a4next">
                                <div class="line1"></div>
                                <div class="line2"></div>
                            </div>
                        </div>
                        <div class="a4_main_right_banner" id="a4banner">
                            <div class="a4_main_right_item a4_main_right_item1">
                                <div class="a4_main_right_item_title">开设科目</div>
                                <div class="a4_main_right_item_cont1">
                                    <!-- 学习内容涵盖多个方面，包括油画、版画复制、拼贴画、摄影、数字媒体、雕塑、电影与表演等，侧重点取决于具体选修科目。 -->
                                </div>
                                <div class="a4_main_right_item_cont2 a4_cont_height">
                                    <div class="a4_main_right_item_cont2_item">
                                        <p class="cn">视觉艺术系</p>
                                        <p class="en">Visual Arts</p>
                                    </div>
                                    <div class="a4_main_right_item_cont2_item">
                                        <p class="cn">数字媒体系</p>
                                        <p class="en">Digital Media</p>
                                    </div>
                                    <div class="a4_main_right_item_cont2_item">
                                        <p class="cn">时尚设计系</p>
                                        <p class="en">Fashion Design</p>
                                    </div>
                                    <div class="a4_main_right_item_cont2_item">
                                        <p class="cn">工业建筑系</p>
                                        <p class="en">Industrial &<br> Architecture Design</p>
                                    </div>
                                    <div class="a4_main_right_item_cont2_item">
                                        <p class="cn">3D设计</p>
                                        <p class="en">3-Dimensional Design</p>
                                    </div>
                                </div>
                            </div>
                            <div class="a4_main_right_item a4_main_right_item2">
                                <div class="a4_main_right_item_title">RoSSo优势</div>
                                <div class="a4_main_right_item_cont a4_cont_height">
                                    <div class="a4_main_right_item_cont_item">
                                        <p class="p1">官方认证，质量保证</p>
                                        <p class="p2">• RoSSo是爱德思考试局官方授权的BTEC办学&考试中心。证书由官方颁发，全球认可、学分终身有效。</p>
                                    </div>
                                    <div class="a4_main_right_item_cont_item">
                                        <p class="p1">本科直录，核心课程</p>
                                        <p class="p2">• BTEC预科是本科直录的核心课程，匹配英美名校入学要求，助力本科直录。</p>
                                    </div>
                                    <div class="a4_main_right_item_cont_item">
                                        <p class="p1">学术&申请，高效同步</p>
                                        <p class="p2">• BTEC产出可与院校申请作品集融合，合理规划学习进度，实现预科学习和作品集创作、院校申请的高效同步</p>
                                    </div>
                                    <div class="a4_main_right_item_cont_item">
                                        <p class="p1">海归名师，精心教研</p>
                                        <p class="p2">• 集结海归名师，匹配爱德思BTEC官方考纲，精心教研，为学生提供专业的艺术预科教育</p>
                                    </div>
                                    <div class="a4_main_right_item_cont_item">
                                        <p class="p1">专业团队，严格把控</p>
                                        <p class="p2">• 专业的教学和审核团队，严格把控学习进度，为学生提供阶段性审核反馈</p>
                                    </div>
                                    <div class="a4_main_right_item_cont_item">
                                        <p class="p1">不出国门，高性价比</p>
                                        <p class="p2">• 在国内即可完成预科学习，免去英国一年预科学习时间，省时省力，高性价比</p>
                                    </div>
                                    <div class="a4_main_right_item_cont_item">
                                        <p class="p1">优质资源，丰富经验</p>
                                        <p class="p2">• 依托优质的艺术教育资源和丰富的国际课程教学经验，为学生提供优质的预科教育，提升申请竞争力</p>
                                    </div>
                                    <div class="a4_main_right_item_cont_item">
                                        <p class="p1">无需语言，即可入读</p>
                                        <p class="p2">• 入读无需雅思/托福成绩，循序渐进适应英国教育体系</p>
                                    </div>

                                </div>
                            </div>
                            <div class="a4_main_right_item a4_main_right_item3">
                                <div class="a4_main_right_item_title">课程亮点</div>
                                <div class="a4_main_right_item3_cont a4_cont_height">
                                    <div class="a4_main_right_item3_cont_item">
                                        <img src="../img/alevel/Rectangle 1098.jpg" alt="">
                                        <div>
                                            <p>一对一授课，定制化教学辅导<br>
                                                课程时间灵活安排</p>
                                        </div>
                                    </div>
                                    <div class="a4_main_right_item3_cont_item">
                                        <img src="../img/alevel/Rectangle 1103.jpg" alt="">
                                        <div>
                                            <p>精心研读官方考纲，<br>
                                                考点全面拆解，核心内容教学</p>
                                        </div>
                                    </div>
                                    <div class="a4_main_right_item3_cont_item">
                                        <img src="../img/BTEC/Rectangle 1105.jpg" alt="">
                                        <div>
                                            <p>
                                                强调理论学习与实践的结合
                                            </p>
                                        </div>
                                    </div>
                                    <div class="a4_main_right_item3_cont_item">
                                        <img src="../img/BTEC/Rectangle 1106.jpg" alt="">
                                        <div>
                                            <p>教学方法灵活，运用调研、实验、答辩<br>
                                                等形式引导学生独立完成项目课题,
                                            </p>
                                        </div>
                                    </div>
                                    <div class="a4_main_right_item3_cont_item">
                                        <img src="../img/alevel/Rectangle 1106.jpg" alt="">
                                        <div>
                                            <p>阶段性审核反馈, <br>
                                                实现阶梯式成长
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="a4_main_right_item a4_main_right_item1">
                                <div class="a4_main_right_item_title">开设科目</div>
                                <div class="a4_main_right_item_cont1">
                                    学习内容涵盖多个方面，包括油画、版画复制、拼贴画、摄影、数字媒体、雕塑、电影与表演等，侧重点取决于具体选修科目。
                                </div>
                                <div class="a4_main_right_item_cont2 a4_cont_height">
                                    <div class="a4_main_right_item_cont2_item">
                                        <p class="cn">纯艺</p>
                                        <p class="en">Fine Art</p>
                                    </div>
                                    <div class="a4_main_right_item_cont2_item">
                                        <p class="cn">摄影</p>
                                        <p class="en">Photography</p>
                                    </div>
                                    <div class="a4_main_right_item_cont2_item">
                                        <p class="cn">平面设计</p>
                                        <p class="en">Graphic Design</p>
                                    </div>
                                    <div class="a4_main_right_item_cont2_item">
                                        <p class="cn">纺织</p>
                                        <p class="en">Textiles</p>
                                    </div>
                                    <div class="a4_main_right_item_cont2_item">
                                        <p class="cn">3D设计</p>
                                        <p class="en">3-Dimensional Design</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="a5">
            <div class="a2_position"></div>
            <div class="section_title">
                <span class="section_cn">官方资料参考</span>
                <p class="section_en"></p>
            </div>
            <div class="a5_cont">
                <div class="a5_item">
                    <div class="a5_item_show" @click="a5Show(0)">
                        <div class="a5_item_show_title">• 英国大学艺术专业本科入学要求参考</div>
                        <div class="cha" style="transform: rotate(225deg);">
                            <div class="cha_line1"></div>
                            <div class="cha_line2"></div>
                        </div>
                    </div>

                    <div class="grid" style="grid-template-rows: 1fr;">
                        <div class="a5_item_hid">
                            <div class="a5_item_hid_table">
                                <table>
                                    <tr style="font-weight: bold;">
                                        <td style="width: 270px;font-size: 22px;background-color: #DFB476;padding: 10px;">专业
                                        </td>
                                        <td style="width: 200px;font-size: 22px;background-color: #DFB476;padding: 10px;">院校
                                        </td>
                                        <td style="width: 465px;font-size: 22px;background-color: #DFB476;padding: 10px;">
                                            录取要求</td>
                                    </tr>
                                    <tr>
                                        <td>BA (Hons) Graphic<br> Communication Design <br>视觉传达设计</td>
                                        <td class="td16">中央圣马丁<br>艺术设计学院</td>
                                        <td>
                                            One or a combination of the following accepted full Level 3 qualifications:<br>
                                             • Pass at Foundation Diploma in Art and Design (Level 3 or 4) and one A Level at grade C or above <br>
                                             • Two A Levels at grade C or above (preferred subjects include Art, Art and Design or Design and Technology) <br>
                                             • Merit, Pass, Pass (MPP) at BTEC Extended Diploma (preferred subjects include Art, Art and Design or Design and Technology) <br>
                                             • Pass at UAL Extended Diploma <br>
                                             • Access to Higher Education Diploma (preferred subjects include Art, Art and Design or Design and Technology)
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>BA (Hons) Fashion Design<br> Technology: <br>Womenswear <br>服装设计技术：女装</td>
                                        <td class="td16">伦敦时装学院</td>
                                        <td>
                                            One or a combination of the following accepted full Level 3 qualifications: <br>
                                            • Pass at Foundation Diploma in Art and Design (Level 3 or 4) and one A Level at grade C or above<br>
                                             • Merit, Pass, Pass (MPP) at BTEC Extended Diploma (preferred subjects include Art, Art and Design or Design and Technology) <br>
                                             • Pass at UAL Extended Diploma <br>
                                             • Access to Higher Education Diploma equivalent to 64 UCAS tariff points (preferred subjects include Art, Art and Design or Design and Technology） <br>
                                             • Pass at Foundation Diploma in Art and Design (Level 3 or 4) plus equivalent EU/international qualifications, such as International Baccalaureate Diploma (24 points)
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>BA (Hons) Fashion<br> Photography <br>时尚摄影</td>
                                        <td>伦敦时装学院</td>
                                        <td>
                                            One or a combination of the following accepted full level 3 qualifications. <br>
                                            • 112 UCAS tariff points from two or more A Levels (preferred subjects include Art, Design, Fashion, Media Studies and Photography); <br>
                                            • Distinction at Foundation Diploma in Art and Design; <br>
                                            • Distinction, Merit, Merit at BTEC Extended Diploma (preferred subjects Art & Design); <br>
                                            • Merit at UAL Extended Diploma; <br>
                                            • Access Diploma or 112 new UCAS tariff points from the Access to HE Diploma; <br>
                                            • or equivalent EU or non-EU qualifications such as International Baccalaureate Diploma at 25 points minimum;<br>
                                            • and three GCSE passes at grade A*-C or grade 9-4.
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>BA (Hons) <br>Fine Art<br> 纯艺</td>
                                        <td>伦敦大学 <br>金史密斯学院</td>
                                        <td>
                                            • Successful completion of three A-levels, International Baccalaureate or an equivalent qualification<br> 
                                            • PLUS successful completion of an Art and Design Foundation diploma <br>
                                            成功获得Art and Design预科文凭 Portfolio of work
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>BA (Hons)<br> Interior Design <br>室内设计</td>
                                        <td>金斯顿大学</td>
                                        <td>
                                            Level 3 qualifications, including Art and Design subjects (i.e. A-levels, BTEC Diploma, IB Diploma, etc.). <br>
                                            The preferred entry route is to first take a Foundation Diploma in Art and Design or recognised equivalent course. <br>
                                            首选的入学途径是先获得Art and Design预科文凭或受认可的同等课程。
                                        </td>
                                    </tr>
                                </table>
                            </div>

                        </div>
                    </div>
                </div>

                <div class="a5_item">
                    <div class="a5_item_show" @click="a5Show(1)">
                        <div class="a5_item_show_title">• BTEC课程体系</div>
                        <div class="cha">
                            <div class="cha_line1"></div>
                            <div class="cha_line2"></div>
                        </div>
                    </div>
                    <div class="grid">
                        <div class="a5_item_hid">
                            <div class="a5_item2_title">
                                BTEC Level 4 Foundation Diploma in Art, Design and Media Practice对应英国国家证书体系的4级。
                            </div>
                            <div class="a5_item2_table">
                                <table>
                                    <tr>
                                        <td
                                            style="width: 308px;font-size:22px;font-weight:bold;background-color: #DFB476;padding: 10px;">
                                            英国国家证书体系级别</td>
                                        <td
                                            style="width: 259px;font-size:22px;font-weight:bold;background-color: #DFB476;padding: 10px;">
                                            高等教育证书序列</td>
                                        <td
                                            style="width: 426px;font-size:22px;font-weight:bold;background-color: #DFB476;padding: 10px;">
                                            对应爱德思资格证书</td>
                                    </tr>
                                    <tr>
                                        <td>7级</td>
                                        <td>Master's Degree <br>硕士<br> MA, MSc, MPhil</td>
                                        <td>BTEC高级专业证书
                                            </td>
                                    </tr>
                                    <tr>
                                        <td>6级</td>
                                        <td rowspan="3">University Degree <br> 本科<br> BA, BSc</td>
                                        <td>BTEC高级专业证书<br>
                                            </td>
                                    </tr>
                                    <tr>
                                        <td>5级</td>
                                        <!-- <td></td> -->
                                        <td>BTEC专业证书<br>
                                            </td>
                                    </tr>
                                    <tr>
                                        <td>4级</td>
                                        
                                        <td>Foundation Degree <br>BTEC预科证书
                                        </td>

                                    </tr>
                                    <tr>
                                        <td>3级</td>
                                        <td>高中</td>
                                        <td>GCE A levels / IAL
                                        </td>

                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="a5_item">
                    <div class="a5_item_show" @click="a5Show(2)">
                        <div class="a5_item_show_title">• BTEC-L4 教学目标 & 评估标准</div>
                        <div class="cha">
                            <div class="cha_line1"></div>
                            <div class="cha_line2"></div>
                        </div>
                    </div>
                    <div class="grid">
                        <div class="a5_item_hid">
                            
                            <div class="a5_item2_table">
                                <table>
                                    <tr>
                                        <td style="width: 320px;">Investigation</td>
                                        <td style="width: 680px;">
                                            Conduct investigation to inform and support creative practice<br> 进行调研，为创造性实践提供信息和支持
                                        </td>
                                        
                                       
                                    </tr>
                                    <tr>
                                        <td>Experimentation</td>
                                        <td>Use iterative experimentation to inform concepts and creative practice <br>不断的尝试和学习新的表现手法，以及完成实践</td>
                                    </tr>
                                    <tr>
                                        <td>Evaluation and Review</td>
                                        <td>Apply processes of evaluation and review to inform creative practice <br>回顾和反思学习成果，进一步推进创造性实践</td>
                                    </tr>
                                    <tr>
                                        <td>Realisation</td>
                                        <td>Apply techniques to realise creative intentions<br> 运用技巧来实现创造性的意图</td>
                                    </tr>
                                    <tr>
                                        <td>Communication</td>
                                        <td>Communicate ideas and intentions through creative practice and outcomes <br>根据创造性实践成果加强想法与意图的交流</td>
                                    </tr>
                                    <tr>
                                        <td>Self-directed Practice</td>
                                        <td>Demonstrate engagement with self-directed practice<br> 多维度展示作品成果</td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="a5_item">
                    <div class="a5_item_show" @click="a5Show(3)">
                        <div class="a5_item_show_title">• BTEC 考试评估标准</div>
                        <div class="cha">
                            <div class="cha_line1"></div>
                            <div class="cha_line2"></div>
                        </div>
                    </div>
                    <div class="grid">
                        <div class="a5_item_hid">
                            <div class="a5_item3_hid_cont">
                                <div class="a5_item3_hid_title"> 
                                    <span>• 两次Formative assessment </span>阶段性考核 <br>（不占最终分值，考核记录提交外审）</div>
                                <div class="a5_item3_hid_box">
                                 
                                    <div>
                                        评估内容包含：<br>
                                        1. Assignment Brief <br>
                                        2. 符合Assignment Brief要求的作品
                                        
                                    </div>
                                </div>
                            </div>
                            <div class="a5_item3_line"></div>
                            <div class="a5_item3_hid_cont">
                                <div class="a5_item3_hid_title"> <span>• 一次Summative assessment</span> <br>评估占比：100%</div>
                                <div class="a5_item3_hid_box">
                                  
                                    <div>
                                        评估内容包含：<br>
                                        1. Project Proposal <br>
                                        2. 成品制作（过程性记录+作品呈现）<br>
                                         Critical reflection文章
                                       
                                       
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="section_inp a6" style="margin-top: 180px;">
            <div class="s_inp_left">
                <img src="../img/shouchahua.png" alt="" class="img_shou  wow rotateInDownLeft" id="imgShou">
                <img src="../img/BTEC/Group 638.png" alt="" class="img_text  wow rollIn" id="imgText">
            </div>
            <div class="s_inp_right">
                <el-form :inline="true" :label-position="labelPosition" label-width="150px" :model="formLabelAlign">
                    <el-form-item label="姓名：">
                        <el-input v-model="formLabelAlign.name" placeholder="请输入姓名"></el-input>
                    </el-form-item>
                    <el-form-item label="意向专业：" class="elitem2">
                        <el-select v-model="formLabelAlign.region" placeholder="选择意向专业">
                            <el-option label="服装设计" value="服装设计"></el-option>
                            <el-option label="景观设计" value="景观设计"></el-option>
                            <el-option label="工业设计" value="工业设计"></el-option>
                            <el-option label="插画设计" value="插画设计"></el-option>
                            <el-option label="动画设计" value="动画设计"></el-option>
                            <el-option label="建筑设计" value="建筑设计"></el-option>
                            <el-option label="交互设计" value="交互设计"></el-option>
                            <el-option label="室内设计" value="室内设计"></el-option>
                            <el-option label="其他" value="其他"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="电话：">
                        <el-input v-model="formLabelAlign.tel" placeholder="请输入电话号码"></el-input>
                    </el-form-item>
                    <el-form-item label="意向国家：" class="elitem2">
                        <el-select v-model="formLabelAlign.region2" placeholder="选择意向国家">
                            <el-option label="英国" value="England"></el-option>
                            <el-option label="美国" value="America"></el-option>
                            <el-option label="日本" value="Japan"></el-option>
                            <el-option label="新加坡" value="Singapore"></el-option>
                            <el-option label="韩国" value="Korea"></el-option>
                            <el-option label="欧洲" value="Europe"></el-option>

                            <el-option label="其他" value="Other"></el-option>
                        </el-select>
                    </el-form-item>
                    <!-- <el-form-item label="意向专业：">
                    <el-input v-model="formLabelAlign.major" placeholder="请输入意向专业"></el-input>
                </el-form-item> -->
                    <el-form-item class="yuyue_box">
                        <div class="yuyue" @click="onSubmit()"></div>
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </div>
</template>
<script>
import "@/assets/css/btec.css"
import { WOW } from 'wowjs'
import axios from "axios"
export default {
    data() {
        return {
            imgsArr: [
                require("../img/alevel/Group 632.png"),
                require("../img/alevel/Group 637.png"),
                require("../img/alevel/Group 634.png"),
                require("../img/alevel/Group 540.png"),
                require("../img/alevel/Group 633.png"),
                require("../img/alevel/Group 635.png"),
                require("../img/alevel/Group 636.png"),
            ],
            imgsArr2: [
                require("../img/alevel/Group 632-1.png"),
                require("../img/alevel/Group 637-1.png"),
                require("../img/alevel/Group 634-1.png"),
                require("../img/alevel/Group 540-1.png"),
                require("../img/alevel/Group 633-1.png"),
                require("../img/alevel/Group 635-1.png"),
                require("../img/alevel/Group 636-1.png"),
            ],
            a4i: 0,
            tableData: [{
                date: '2016-05-02',
                name: '王小虎',
                address: '上海市普陀区金沙江路 1518 弄'
            }, {
                date: '2016-05-04',
                name: '王小虎',
                address: '上海市普陀区金沙江路 1517 弄'
            }, {
                date: '2016-05-01',
                name: '王小虎',
                address: '上海市普陀区金沙江路 1519 弄'
            }, {
                date: '2016-05-03',
                name: '王小虎',
                address: '上海市普陀区金沙江路大撒大撒大撒大苏打撒大苏打的陀区金沙江路大撒大撒大撒大苏打撒大苏打的撒 撒 1516 弄'
            }],
            labelPosition: 'right',
            formLabelAlign: {
                name: '',
                tel: '',
                region: '',
                region2: '',
                budget: '',
            },
        }
    },
    methods: {
        scrolla2item(val){
            // console.log(val);
            var a2_position = document.getElementsByClassName("a2_position")
            var a2_left_item = document.getElementsByClassName("a2_left_item")
            for(var i =0;i<a2_left_item.length;i++){
                a2_left_item[i].style.opacity = "0.5"
            }
            a2_left_item[val].style.opacity = "1"
            a2_position[val].scrollIntoView({
                block: 'start',
                behavior: 'smooth',

            })
        },
        onSubmit() {
            // console.log('submit!',this.formInline);
            var currentURL = window.location.href;
            var status = ''
            // 检查 URL 中是否包含某些关键词，来判断使用的搜索引擎
            if (currentURL.includes("google")) {
                status = "用户正在使用 Google 搜索引擎"
            } else if (currentURL.includes("bing")) {
                status = "用户正在使用 Bing 搜索引擎"
            } else if (currentURL.includes("yahoo")) {
                status = "用户正在使用 Yahoo 搜索引擎"
            } else if (currentURL.includes("baidu")) {
                status = "用户正在使用 百度 搜索引擎"
            } else {
                status = "无法确定用户使用的搜索引擎"
            }
            var patt = /^1[3-9][0-9]{9}$/

            if (this.formLabelAlign.name == "" || this.formLabelAlign.tel == "") {
                // console.log("姓名和手机号不能为空");
                this.$message.error('姓名和手机号不能为空');

            } else {
                // console.log("不是空");

                if (patt.test(this.formLabelAlign.tel)) {

                    // console.log("可以发请求");
                    // console.log(this.formInline);
                    axios.post("https://public.rossoarts.com/index/common/getform", {
                        "name": this.formLabelAlign.name,
                        "tel": this.formLabelAlign.tel,
                        "budget": this.formLabelAlign.budget,
                        "intended_country":this.formLabelAlign.region2,
                        "url": window.location.href,
                        "status":status,
                    }).then((data) => {
                        console.log(data, "response");
                        this.$message({
                            message: '提交成功',
                            type: 'success'
                        });
                    }).catch(function (error) {
                        console.log(error, "error");
                    });

                } else {
                    console.log("手机号格式不正确");
                    this.$message.error('手机号格式不正确');

                }

            }


        },
        a5Show(val) {
            // console.log(val);
            var cha = document.getElementsByClassName("cha")
            var grid = document.getElementsByClassName("grid")
            // var t6_item_show = document.getElementsByClassName("t6_item_show")
            // var t6_imgQ = document.getElementsByClassName("t6_imgQ")
            // this.flag = !this.flag
            // console.log(grid[val].style.gridTemplateRows,val);
            if (grid[val].style.gridTemplateRows == "1fr") {
                // 折叠
                // console.log("不出");
                grid[val].style.gridTemplateRows = "0fr";
                cha[val].style.transform = "rotate(0deg)"
                // t6_item_show[val].style.backgroundColor = "#5f9df7"
                // t6_item_show[val].style.border = "none"
                // t6_item_show[val].style.margin = "0px"
                // t6_imgQ[val].style.visibility = "visible"
            } else {
                // 展开
                // console.log("出");
                grid[val].style.gridTemplateRows = "1fr";
                cha[val].style.transform = "rotate(225deg)"
                // t6_item_show[val].style.backgroundColor = "#FB6333"
                // t6_item_show[val].style.border = "2px solid #000"
                // t6_item_show[val].style.margin = "-2px -2px 0 -2px"
                // t6_imgQ[val].style.visibility = "hidden"

            }
        },
        dotClick(val) {
            // console.log(val);
            var a4_main_left_item = document.getElementsByClassName("a4_main_left_item")
            for (var i = 0; i < a4_main_left_item.length; i++) {
                a4_main_left_item[i].style.fontWeight = "400"
            }
            a4_main_left_item[val].style.fontWeight = "bold"
            this.a4i = val
            a4banner.style.transform = `translateX(${-915 * this.a4i}px)`
            a4banner.style.height  = $(".a4_cont_height").eq(this.a4i).height() +100+ "px"
        },
        a4next() {
            var a4_main_left_item = document.getElementsByClassName("a4_main_left_item")
            // var a4_main_right_item = document.getElementsByClassName("a4_main_right_item")
            this.a4i++;
            // console.log(a4_main_right_item[this.a4i]);
            // a4banner.style.height = a4_main_left_item[this.a4i].style.height
            a4banner.style.transform = `translateX(${-915 * this.a4i}px)`
            a4banner.style.transition = 'all .36s'
            if (this.a4i == 3) {
                this.a4i = 0;
                setTimeout(() => {
                    a4banner.style.transform = 'translate(0,0)';
                    a4banner.style.transition = 'none'
                }, 360);

            }
            for (var i = 0; i < a4_main_left_item.length; i++) {
                a4_main_left_item[i].style.fontWeight = "400"
            }
            a4_main_left_item[this.a4i].style.fontWeight = "bold"
            a4banner.style.height  = $(".a4_cont_height").eq(this.a4i).height() +100+ "px"
        },
        a4prev() {
            var a4_main_left_item = document.getElementsByClassName("a4_main_left_item")
            this.a4i--;
            if (this.a4i == -1) {
                this.a4i = 2;//length - 1

                a4banner.style.transition = 'none'

                a4banner.style.transform = `translateX(${-915 * (this.a4i + 1)}px)`
                setTimeout(() => {
                    a4banner.style.transform = 'translateX(' + (-this.a4i * 915) + 'px)';
                    a4banner.style.transition = 'all .36s'
                }, 1);

            } else {
                a4banner.style.transition = 'all 0.36s'
                a4banner.style.transform = `translateX(${-915 * this.a4i}px)`
            }
            for (var i = 0; i < a4_main_left_item.length; i++) {
                a4_main_left_item[i].style.fontWeight = "400"
            }
            a4_main_left_item[this.a4i].style.fontWeight = "bold"
            a4banner.style.height  = $(".a4_cont_height").eq(this.a4i).height() +100+ "px"

        },
        a3itemClick(val) {
            // console.log(val);
            var a3_item_bgc = document.getElementsByClassName("a3_item_bgc")
            var a3_item = document.getElementsByClassName("a3_item")
            var a3_item_text = document.getElementsByClassName("a3_item_text")
            var a3_item_text_cont = document.getElementsByClassName("a3_item_text_cont")
            var a3_item_text_icon = document.getElementsByClassName("a3_item_text_icon")

            if (a3_item_text_cont[val].style.display == "block") {
                a3_item_bgc[val].src = this.imgsArr2[val]
                a3_item_text[val].style.height = "40px"
                a3_item_text[val].style.marginTop = "95px"
                a3_item[val].style.backgroundColor = "#5F9DF7"
                a3_item_text_cont[val].style.display = "none"
                a3_item_text_icon[val].src = require("../img/alevel/Group 643.png")
                a3_item[val].style.height = "165px"
            } else {
                a3_item_bgc[val].src = this.imgsArr[val]
                a3_item_text[val].style.height = "230px"
                a3_item_text[val].style.marginTop = "25px"
                a3_item[val].style.backgroundColor = "#2E7FF5"
                a3_item[val].style.height = "282px"
                a3_item_text_cont[val].style.display = "block"
                a3_item_text_icon[val].src = require("../img/alevel/Group 644.png")
            }
        },
        imgCover() {
            // var img = document.getElementsByTagName("img")
            var coverBlack = document.getElementById("coverBlack")
            var img1 = document.getElementsByClassName("img1")
            console.log(coverBlack);
            coverBlack.style.display = "block"
            coverMainImg.src = img1[0].src
            // console.log(img);
            // console.log(e.target.src);

        },
    },
    mounted() {
        var init = new WOW().init();


    }
}
</script>